export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
            联系投稿
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            如果你有影视资源推荐、内容合作或任何建议，欢迎通过以下方式联系我们。丫丫影院期待与更多优质内容创作者携手，为观众带来更丰富的观影选择。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">contact@yayacinema.com</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">官方微信</h3>
              <p className="text-xs text-foreground-500">yayacinema</p>
            </div>
            <div className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-team-line text-lg"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-1">内容合作</h3>
              <p className="text-xs text-foreground-500">商务合作洽谈</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}